import React from "react"
import ActivityBase from "@/components/activities/base"
import OwnerLabel from "@/components/activities/owner_label"
import i18n from "@/i18n"
import Changes from "@/components/activities/changes"

interface CreatedProps {
  activity: any
  className?: string
}

const Created = ({ activity, className }: CreatedProps) => {
  const LABELS = {
    name: i18n.t("app.activities.venue.field_labels.name"),
    country: i18n.t("app.activities.venue.field_labels.country"),
    timezone: i18n.t("app.activities.venue.field_labels.timezone"),
  }

  const formatters = {}

  return (
    <ActivityBase
      data-testid="panel-activity-venue-created"
      activityKey={activity.key}
      createdAt={activity.createdAt}
      text={
        <>
          {i18n.react("app.activities.venue.created.description", {
            owner: <OwnerLabel owner={activity.owner} />,
          })}
          <Changes changes={activity.parameters} labels={LABELS} formatters={formatters} />
        </>
      }
      className={className}
    />
  )
}

export default Created
